/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import { useParams } from 'react-router';
import ClearCreekQuestions from '../components/registration/ClearCreekQuestions';
import ClearCreekResults from '../components/registration/ClearCreekResults';
import { CLEAR_CREEK_PERMIT_ID } from '../utils/utils';
import PermitRegistrationPageHOC from './PermitRegistrationPageHOC';

const componentMapping = {
    [CLEAR_CREEK_PERMIT_ID]: [ClearCreekQuestions, ClearCreekResults],
};

export default function PermitRegistrationPage() {
    const { permitId } = useParams();

    const compSet = componentMapping[permitId];

    if (!compSet) {
        return null;
    }

    const ChildComponent = PermitRegistrationPageHOC(compSet[0], compSet[1]);

    return <ChildComponent />;
}
